import { useQuery } from "@tanstack/react-query";
import { ownerApi } from "@/lib/api";
import { Spinner, EmptyState } from "@/components/common/States";

export default function OwnerReferrals() {
  const records = useQuery({ queryKey: ["ownerReferrals"], queryFn: ownerApi.getReferrals });
  const leaders = useQuery({ queryKey: ["ownerReferralLeaders"], queryFn: ownerApi.getReferralLeaderboard });
  if (records.isPending) return <Spinner />;
  return (
    <div className="grid gap-6 lg:grid-cols-2">
      <div>
        <h3 className="mb-3 font-display text-sm font-bold">Leaderboard</h3>
        {!leaders.data?.length ? <EmptyState title="No referrals yet" /> : (
          <div className="space-y-2">
            {leaders.data.map((l, i) => (
              <div key={l.phone} className="flex items-center justify-between rounded-xl border border-border bg-card p-3 text-sm">
                <span className="font-medium">{i + 1}. {l.name || l.phone}</span>
                <span className="text-muted-foreground">{l.count} referrals · {l.points} pts</span>
              </div>
            ))}
          </div>
        )}
      </div>
      <div>
        <h3 className="mb-3 font-display text-sm font-bold">Recent referrals</h3>
        {!records.data?.length ? <EmptyState title="Nothing yet" /> : (
          <div className="space-y-2">
            {records.data.map((r, i) => (
              <div key={i} className="rounded-xl border border-border bg-card p-3 text-sm">
                <p className="font-medium">{r.referrer_name} → {r.referee_name}</p>
                <p className="text-xs text-muted-foreground">{r.code} · {r.booking_code || "pending"} · {r.status} · +{r.bonus} pts</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
